import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { FtueCatalogKey } from './ftue.i18n.js';
import { FTUE_CATALOG } from './ftue.i18n.js';

export type FtueMessageId = `ftue:${FtueCatalogKey}`;

const PREFIX_LENGTH = 'ftue:'.length;

/** `t()` for the stop-gap `ftue:` scope (see `ftue.i18n.ts`). */
export function useFtueT(): { t: (id: FtueMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: FtueMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as FtueCatalogKey;
      const raw = FTUE_CATALOG[locale][key] ?? FTUE_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
